import type { Reducer } from 'redux';
import { combineReducers } from 'redux';
import { reducer as accountDetailsReducer } from 'b2b-apps/shop/myAccount/accountDetails/redux/reducer';
import { reducer as addressesReducer } from 'b2b-apps/shop/myAccount/addresses/redux/reducer';
import { reducer as balanceDetailsReducer } from 'b2b-apps/shop/myAccount/balanceDetails/redux/reducer';
import { reducer as creditsReducer } from 'b2b-apps/shop/myAccount/credits/redux/reducer';
import { reducer as deliveredOrdersReducer } from 'b2b-apps/shop/myAccount/deliveredOrders/redux/reducer';
import { reducer as invoicesReducer } from 'b2b-apps/shop/myAccount/invoices/redux/reducer';
import { reducer as sendEmailReducer } from 'b2b-apps/shop/myAccount/invoices/redux/sendEmail/reducer';
import { reducer as newslettersReducer } from 'b2b-apps/shop/myAccount/newsletters/redux/reducer';
import { reducer as ordersReducer } from 'b2b-apps/shop/myAccount/orders/redux/reducer';
import { reducer as pdfReducer } from 'b2b-apps/shop/myAccount/pdf/redux/reducer';
import { reducer as rmaReducer } from 'b2b-apps/shop/myAccount/rma/redux/reducer';
import { reducer as usersReducer } from 'b2b-apps/shop/myAccount/users/redux/reducer';
import { reducer as wishlistsReducer } from 'b2b-apps/shop/myAccount/wishlists/redux/reducer';
import type { MyAccountActions, MyAccountState } from './types';

const reducer: Reducer<MyAccountState, MyAccountActions> = combineReducers({
  addresses: addressesReducer,
  accountDetails: accountDetailsReducer,
  credits: creditsReducer,
  invoices: invoicesReducer,
  newsletters: newslettersReducer,
  orders: ordersReducer,
  deliveredOrders: deliveredOrdersReducer,
  pdf: pdfReducer,
  rma: rmaReducer,
  users: usersReducer,
  wishlists: wishlistsReducer,
  balanceDetails: balanceDetailsReducer,
  sendEmail: sendEmailReducer,
});

export {
  reducer,
};
